var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-empty',{attrs:{"description":"页面跳转中..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }